import { useEffect, useState } from 'react'
import { MapModalProvider } from '../../hook/MapModalProvider'
import { buildTimestampControlKpis } from '../helpers/timestampControlExportData'
import { Clock } from '@phosphor-icons/react'
import { getTimestampCardSubtitle } from '../helpers/cardCopy'
import TimestampReportMapModal from '../components/maps/TimestampReportMapModal'
import TimestampControlMobileContent from '../mobile/TimestampControlMobileContent'
import TimestampControlTable from '../components/TimestampControlTable'

const TimestampControlTab = ({
  currentPage,
  totalPages,
  totalCount,
  perPage,
  setCurrentPage,
  onRowsPerPageChange,
  salesmanName,
  timestampData,
  timestampSummary = {},
  isTimestampSameDay,
  isMobileLayout = false,
  initialExpandedTimestampKey = null
}) => {
  const [timestampDataSelected, setTimestampDataSelected] = useState(false)
  const [timestampShow, setTimestampShow] = useState(false)
  const [expandedTimestampKey, setExpandedTimestampKey] = useState(initialExpandedTimestampKey)
  const [shouldRenderMobileMap, setShouldRenderMobileMap] = useState(false)

  const handleTimestampClose = () => {
    setTimestampShow(false)
    setShouldRenderMobileMap(false)
    setTimestampDataSelected(false)
  }

  const handleTimestampShow = (model, event) => {
    event.preventDefault()
    setTimestampDataSelected(model)
    setTimestampShow(true)
  }

  const toggleExpandedTimestamp = (timestampKey) => {
    setExpandedTimestampKey((prev) => (prev === timestampKey ? null : timestampKey))
  }

  useEffect(() => {
    if (!timestampShow || !timestampDataSelected) {
      setShouldRenderMobileMap(false)
      return
    }

    if (!isMobileLayout) {
      setShouldRenderMobileMap(true)
      return
    }

    setShouldRenderMobileMap(false)
    const timeoutId = window.setTimeout(() => {
      setShouldRenderMobileMap(true)
    }, 90)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [timestampShow, timestampDataSelected, isMobileLayout])

  const buildTimestampKpiData = () => ({
    timestampControlOverview: buildTimestampControlKpis(
      timestampSummary,
      isTimestampSameDay,
      Boolean(timestampData)
    ).map(({ title, value }) => ({ text: title, value }))
  })

  const timestampCardsSection = (kpiData) => {
    if (!kpiData) return null
    return (
      <section className="rp-kpi-frame timestamp-totals-frame" aria-label="Resumen de horario">
        <div className="activity-totals timestamp-totals">
          {kpiData.timestampControlOverview.map((item) => (
            <article key={item.text} className="activity-total timestamp-total">
              <span className="activity-total-heading">
                <span className="rp-section-icon">
                  <Clock size={18} color="#597FA9" aria-hidden="true" />
                </span>
                {item.text}
              </span>
              <strong>{item.value}</strong>
              <small>
                {getTimestampCardSubtitle({ title: item.text, isSameDay: isTimestampSameDay })}
              </small>
            </article>
          ))}
        </div>
      </section>
    )
  }

  return (
    <MapModalProvider>
      <div
        className={`rp-preview rp-connected-route timestamp-control${isMobileLayout ? ' timestamp-control-mobile' : ''}`}
      >
        {timestampCardsSection(buildTimestampKpiData())}
        {isMobileLayout ? (
          <TimestampControlMobileContent
            timestampData={timestampData}
            expandedTimestampKey={expandedTimestampKey}
            onToggleExpand={toggleExpandedTimestamp}
            onOpenLocation={handleTimestampShow}
          />
        ) : (
          <TimestampControlTable
            rows={timestampData}
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            perPage={perPage}
            onPageChange={setCurrentPage}
            onRowsPerPageChange={(_, nextPerPage) => onRowsPerPageChange?.(nextPerPage)}
            onOpenLocation={handleTimestampShow}
          />
        )}
      </div>
      <TimestampReportMapModal
        show={timestampShow && Boolean(timestampDataSelected)}
        onHide={handleTimestampClose}
        isMobileLayout={isMobileLayout}
        salesmanName={salesmanName}
        timestamp={timestampDataSelected}
        shouldRenderMobileMap={shouldRenderMobileMap}
      />
    </MapModalProvider>
  )
}
export default TimestampControlTab
